import { useTranslation } from 'react-i18next';

import ArrowRightShape from '@/components/common/svg/shapes/ArrowRightShape.tsx';
import { blockContainer } from '@/components/ProfileData/Blocks/styles.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';

interface ProfileBioBlockProps {
  onOpen: () => void;
}

export const ProfileBioBlock = ({ onOpen }: ProfileBioBlockProps) => {
  const { t } = useTranslation();
  const { aboutMe } = useProfileStore();

  return (
    <div style={{ ...blockContainer, padding: 16 }} onClick={onOpen}>
      <span
        style={{
          flexGrow: 1,
          textAlign: 'left',
          whiteSpace: 'pre-wrap',
          color: aboutMe ? '#000' : '#999',
          fontSize: '15px',
          lineHeight: '1.5',
          fontWeight: aboutMe?.profile.about_me ? '400' : '400'
        }}
      >
        {aboutMe?.profile.about_me || t('bio_placeholder')}
      </span>
      <ArrowRightShape
        width={14}
        height={14}
        fillColor="#C8C8CB"
        style={{ flexShrink: 0 }}
      />
    </div>
  );
};
